import { useState, useEffect, useCallback } from 'react'
import Lottie from "react-lottie";
import request from '../helpers/request';

const WaitingPage = () => {
    const [lottieSize, setLottieSize] = useState(350)
    const [title, setTitle] = useState("")
    const [description, setDescription] = useState("")
    const [svgLogo, setSvgLogo] = useState("")
    const [lottieData, setLottieData] = useState(null)
    const [styles, setStyles] = useState({})


    const handleResize = useCallback(() => {
        const width = window.innerWidth;
        if (width >= 768) {
            setLottieSize(350)
        } else {
            setLottieSize(250)
        }
    }, [])

    const redirect = useCallback((status = '') => {
        const queryParams = new URLSearchParams(window.location.search);
        const task_id = queryParams.get('task_id')
        const redirect_url = queryParams.get('redirect_url')
        if (!redirect_url) return
        const url = new URL(redirect_url)
        url.searchParams.set('status', status)
        url.searchParams.set('task_id', task_id)
        window.location.href = url.toString()
    }, [])

    const getPageDetails = useCallback(async (id = '') => {
        try {
            const response = await request.get(`/api/v1/compliance/page/${id}/`)
            setTitle(response.data.title)
            setDescription(response.data.description)
            setStyles(response.data.styles)
            setSvgLogo(response.data.svg_logo)
            setLottieData(response.data.lottie_animation)
        } catch (e) {
            console.log(`Error in getting page details: ${e}`)
            redirect("error")
        }
    }, [redirect])

    useEffect(() => {
        let interval

        const getTaskData = async (id = '', timeoutDelay = 5) => {
            try {
                const response = await request.get(`/api/v1/tools/task/${id}/`)
                const status = response.data.status
                if (status === 'completed' || status === 'failed') {
                    clearInterval(interval)
                    redirect(status)
                }
                const taskCreatedTime = new Date(response.data.created_at)
                const currentTime = new Date()
                let timeDifference = currentTime - taskCreatedTime
                timeDifference /= 60000
                if (timeDifference > timeoutDelay) {
                    clearInterval(interval)
                    redirect("timeout")
                }
            } catch (e) {
                console.error(`Error in getting task data: ${e}`)
                redirect("error")
            }
        }

        const queryParams = new URLSearchParams(window.location.search);
        let task_id = queryParams.get('task_id')
        const page_layout_id = queryParams.get('page_layout')
        const timeoutDelay = queryParams.get('timeout_delay') || 5

        getPageDetails(page_layout_id)
        interval = setInterval(() => {
            getTaskData(task_id, timeoutDelay)
        }, 1000)

        return () => {
            clearInterval(interval)
        }
    }, [getPageDetails, redirect])

    useEffect(() => {
        handleResize()
        window.addEventListener('resize', handleResize)

        return () => {
            window.removeEventListener('resize', handleResize)
        }
    }, [handleResize])


    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: lottieData,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice",
        },
    };

    return (
        <div style={{
            height: '100vh',
            width: '100vw',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            ...(styles.container || {})
        }}>
            {svgLogo && <div style={styles.logo || {}} dangerouslySetInnerHTML={{ __html: svgLogo }} />}
            <h1 style={{ textAlign: 'center', fontSize: '1.5em', ...(styles.title || {}) }}>{title}</h1>
            <h2 style={{ textAlign: 'center', fontSize: '1em', ...(styles.description || {}) }}>{description}</h2>
            {lottieData && <Lottie options={defaultOptions} height={lottieSize} width={lottieSize} />}
        </div>
    );
}

export default WaitingPage;
